import { render } from "./YakitPompasi.vue?vue&type=template&id=c70b4e54"
import script from "./YakitPompasi.vue?vue&type=script&lang=js"
export * from "./YakitPompasi.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\ulas\\Desktop\\projeler\\eku\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__